<mat-toolbar class="subtitulo">Cadastrar ação competência</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
        <form #formCadastro="ngForm">

                <!-- DADOS INICIAIS -->
                <div fxLayout="row" fxLayoutGap="50px" fxFlexFill>
                        <div fxLayout="column" fxFlex="50%" fxLayoutAlign="center stretch" fxFlexFill>
                                <mat-toolbar class="titulopartes">Dados Iniciais</mat-toolbar>
                                <mat-form-field style="margin-left: 20px" fxFlex="95%" appearance="outline">
                                        <mat-label>Descrição:</mat-label>
                                        <textarea matInput #message name="descricao"
                                                [(ngModel)]="acaoCompetencia.descricao" cdkTextareaAutosize
                                                #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2" maxlength="200"
                                                required>
                                         </textarea>
                                        <mat-hint align="end">{{message.value.length}} / 200</mat-hint>
                                </mat-form-field>
                        </div>

                        <!-- DATAS -->
                        <div fxLayout="column" fxFlex="50%" fxLayoutAlign="center stretch" fxFlexFill>
                                <mat-toolbar class="titulopartes">Datas</mat-toolbar>
                                <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px"
                                        fxFlexFill>

                                        <mat-form-field fxFlex="30%" fxFlexOffset="20px">
                                                <input matInput name="dataInicio" [matDatepicker]="dataInicio"
                                                        placeholder="Data de Início"
                                                        [(ngModel)]="acaoCompetencia.dataInicio" (input)="onMascaraDataInput($event)">
                                                <mat-datepicker-toggle matSuffix [for]="dataInicio">
                                                </mat-datepicker-toggle>
                                                <mat-datepicker #dataInicio></mat-datepicker>
                                        </mat-form-field>

                                        <mat-form-field fxFlex="30%">
                                                <input matInput name="dataFim" [matDatepicker]="dataFim"
                                                        placeholder="Data Fim" [(ngModel)]="acaoCompetencia.dataFim" (input)="onMascaraDataInput($event)">
                                                <mat-datepicker-toggle matSuffix [for]="dataFim">
                                                </mat-datepicker-toggle>
                                                <mat-datepicker #dataFim></mat-datepicker>
                                        </mat-form-field>

                                </div>
                        </div>
                </div>


                <!-- TALENTO -->
                <mat-toolbar class="titulopartes">Talento</mat-toolbar>
                <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
                        <mat-form-field fxFlexOffset="20px" fxFlex="55%">
                                <mat-label>Selecione um talento:</mat-label>
                                <mat-select [(ngModel)]="acaoCompetencia.talentosPf.id" name="talentosPf" required>
                                        <mat-option *ngFor="let o of talentos" [value]="o.id">
                                                {{o.respostaTalento}}
                                        </mat-option>
                                </mat-select>
                        </mat-form-field>

                </div>

                

                <!-- RESULTADO ESPERADO -->
                <mat-toolbar class="titulopartes">Resultados</mat-toolbar>
                <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

                        <mat-form-field fxFlex="46%" fxFlexOffset="20px" appearance="outline">
                                <mat-label>Resultado esperado:</mat-label>
                                <textarea matInput #resultadoPrevAcao name="resultadoPrevAcao"
                                        [(ngModel)]="acaoCompetencia.resultadoPrevAcao" cdkTextareaAutosize
                                        #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2" maxlength="200">
                      </textarea>
                                <mat-hint align="end">{{resultadoPrevAcao.value.length}} / 200</mat-hint>
                        </mat-form-field>

                        <mat-form-field fxFlex="46%" fxFlexOffset="20px" appearance="outline">
                                <mat-label>Resultado obtido:</mat-label>
                                <textarea matInput #message name="resultadoAcao"
                                        [(ngModel)]="acaoCompetencia.resultadoAcao" cdkTextareaAutosize
                                        #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2" maxlength="200">
                      </textarea>
                                <mat-hint align="end">{{message.value.length}} / 200</mat-hint>
                        </mat-form-field>

                </div>



                <!-- BOTOES -->
                <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                        fxFlexFill>
                        <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button name="botaoConfirmar"
                                fxFlex="20%" color="primary" [disabled]="formCadastro.invalid" (click)="cadastrar()">
                                Cadastrar
                        </button>

                        <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button name="botaoConfirmar"
                                fxFlex="20%" color="primary" [disabled]="formCadastro.invalid" (click)="atualizar()">
                                Atualizar
                        </button>

                        <button *ngIf="mostrarBotaoLimpar()" mat-raised-button fxFlex="20%" (click)="limpar()">
                                Limpar
                        </button>
                        <button mat-raised-button fxFlex="20%" (click)="cancelar()">
                                Cancelar
                        </button>

                </div>
        </form>


</div>